var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"verification-progress-header my-4 text-center"},[_vm._v("\n  Account verification step "),_c('b',[_vm._v(_vm._s(_vm.currentLabel)+" / "+_vm._s(_vm.qty))])])
}
var staticRenderFns = []

export { render, staticRenderFns }